import { createAsyncThunk } from '@reduxjs/toolkit';
import { RenovationView } from '../../domain/constants/RenovationView';

export const setCurrent = createAsyncThunk(
  'Renovation/setCurrent',
  async (data: {
    currentView: RenovationView;
    url: string;
    actionInProcess: boolean;
    process: any;
    title: string;
  }) => {
    try {
      const renovation = {
        currentView: data?.currentView,
        url: data?.url,
        actionInProcess: data?.actionInProcess,
        process: data?.process,
        title: data?.title,
      };
      return { renovation, error: '' };
    } catch (error) {
      throw error;
    }
  }
);
